import { Stack } from '@mui/material';
import { Match, Show, Switch } from '@side/pantry';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  BuyerAgreementStatus,
  useBuyerAgreementStatus,
} from '../../hooks/useBuyerAgreementStatus';
import { BuyerMethod, type CreateOfferFormData } from '../../types';
import { AgreementTypeField } from '../AgreementTypeField';
import { BuyerAgreementAttachmentSection } from '../BuyerAgreementAttachmentSection/BuyerAgreementAttachmentSection';
import { BuyerInfoCard } from './BuyerInfoCard';
import { HelperText } from './HelperText';
import { NewBuyerPrepareToSend } from './NewBuyerPrepareToSend';

export function BuyerAgreementSection() {
  const [buyer, buyerMethod, type] = useWatch<
    CreateOfferFormData,
    ['buyer', 'buyerMethod', 'type']
  >({
    name: ['buyer', 'buyerMethod', 'type'],
  });
  const {
    formState: { isValid },
  } = useFormContext();

  const buyerAgreementStatus = useBuyerAgreementStatus();

  // Named conditions for readability
  const initialLoad = !buyer && !type;

  const existingBuyerNotReady =
    buyerMethod === BuyerMethod.existingBuyer && !isValid;
  const existingBuyerEnvelope =
    buyerMethod === BuyerMethod.existingBuyer && type === 'envelope';
  const existingBuyerAttachment =
    buyerMethod === BuyerMethod.existingBuyer && type === 'attachment';

  const newBuyerEnvelope =
    buyerMethod === BuyerMethod.newBuyer && type === 'envelope';
  const newBuyerAttachment =
    buyerMethod === BuyerMethod.newBuyer && type === 'attachment';

  return (
    <Stack sx={{ gap: 3 }}>
      <Show when={buyerAgreementStatus === BuyerAgreementStatus.NOT_SENT}>
        <AgreementTypeField disabled={initialLoad || existingBuyerNotReady} />
      </Show>
      <Switch>
        <Match when={initialLoad || existingBuyerEnvelope}>
          <BuyerInfoCard buyer={buyer} />
          <HelperText
            buyer={buyer}
            buyerMethod={buyerMethod}
            loading={initialLoad || existingBuyerNotReady}
          />
        </Match>
        <Match when={newBuyerEnvelope}>
          <NewBuyerPrepareToSend />
        </Match>
        <Match when={existingBuyerAttachment || newBuyerAttachment}>
          <BuyerAgreementAttachmentSection />
        </Match>
      </Switch>
    </Stack>
  );
}
